export const ADMIN_TYPE_ID = 1;
export const WORKER_TYPE_ID = 2;
export const DEV_TYPE_ID = 3;
export const COORDINATOR_TYPE_ID = 4;
export const DRIVER_TYPE_ID = 5;
export const TRANSPORT_MANAGER_TYPE_ID = 6;
export const SUBCONTRACTOR_TYPE_ID = 7;
export const RADO_COORDINATOR_TYPE_ID = 8;
export const RBS_COORDINATOR_TYPE_ID = 9;

// side menu
export const ACCESS_SIDE_MENU_DASHBOARD = {
  userTypesWithAccess: [DEV_TYPE_ID, ADMIN_TYPE_ID]
};
export const ACCESS_SIDE_MENU_ORDER_STATUSES = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    RBS_COORDINATOR_TYPE_ID
  ]
};
export const ACCESS_SIDE_MENU_GEODESY_PHASES = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    RBS_COORDINATOR_TYPE_ID
  ]
};
export const ACCESS_SIDE_MENU_USERS = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    RBS_COORDINATOR_TYPE_ID
  ]
};
export const ACCESS_SIDE_MENU_DICTIONARIES = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    RBS_COORDINATOR_TYPE_ID
  ]
};
export const ACCESS_SIDE_MENU_TRANSPORT_ORDERS = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    TRANSPORT_MANAGER_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    RBS_COORDINATOR_TYPE_ID
  ]
};
export const ACCESS_SIDE_MENU_TRANSPORT_ARCHIVED_ORDERS = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    TRANSPORT_MANAGER_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    RBS_COORDINATOR_TYPE_ID
  ]
};
export const ACCESS_SIDE_MENU_ARCHIVED_ORDERS = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    RBS_COORDINATOR_TYPE_ID
  ]
};
export const ACCESS_SIDE_MENU_REPORTS_HISTORY = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    RBS_COORDINATOR_TYPE_ID
  ]
};
export const ACCESS_SIDE_MENU_ACTIONS_REGISTER = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    RBS_COORDINATOR_TYPE_ID
  ]
};

// orders table
export const ACCESS_ORDERS_TABLE_NEW_ORDER_BUTTON = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    TRANSPORT_MANAGER_TYPE_ID
  ]
};
export const ACCESS_ORDERS_TABLE_EXPORT_BUTTON = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    RBS_COORDINATOR_TYPE_ID
  ]
};
export const ACCESS_ORDERS_TABLE_REQUEST_REPORT_BUTTONS = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    RBS_COORDINATOR_TYPE_ID
  ]
};
export const ACCESS_ORDERS_TABLE_REPORTS_HISTORY_TABS = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    RBS_COORDINATOR_TYPE_ID
  ]
};
export const ACCESS_ORDERS_TABLE_ARCHIVED_TAB = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    RBS_COORDINATOR_TYPE_ID
  ]
};

// orders table filters
export const ACCESS_ORDERS_TABLE_FILTERS_ORDER_STATUS_FILTER = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    RBS_COORDINATOR_TYPE_ID
  ]
};

// order details - tabs
export const ACCESS_ORDER_DETAILS_CONTRACTORS_TAB = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    SUBCONTRACTOR_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    RBS_COORDINATOR_TYPE_ID
  ]
};
export const ACCESS_ORDER_DETAILS_TRANSPORT_TAB = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    RBS_COORDINATOR_TYPE_ID
  ]
};
export const ACCESS_ORDER_DETAILS_ACCEPTANCE_PROTOCOL_TAB = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    RBS_COORDINATOR_TYPE_ID
  ]
};
export const ACCESS_ORDER_DETAILS_GEODETIC_PROTOCOL_TAB = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    RBS_COORDINATOR_TYPE_ID
  ]
};
export const ACCESS_ORDER_DETAILS_REPOSITORY_TAB = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    SUBCONTRACTOR_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    RBS_COORDINATOR_TYPE_ID
  ]
};
export const ACCESS_ORDER_DETAILS_ADDITIONAL_INFO_TAB = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    RBS_COORDINATOR_TYPE_ID
  ]
};
export const ACCESS_ORDER_DETAILS_MAP_POINTS_REPORTS_TAB = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    RBS_COORDINATOR_TYPE_ID
  ]
};

export const ACCESS_ORDER_EDIT_BUTTON = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

// order details - buttons
export const ACCESS_ORDER_DETAILS_ATTACHMENT_6_IMPORT_BUTTON = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};
export const ACCESS_ORDER_DETAILS_ARCHIVE_BUTTON = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

export const ACCESS_ORDER_DETAILS_DELETE_BUTTON = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID]
};

export const ACCESS_ORDER_UPDATE_STATUS = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

export const ACCESS_ORDER_UPDATE_INTERRUPTION_STATUS = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

export const ACCESS_ORDER_UPDATE_PRIORITY = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

export const ACCESS_ORDER_UPDATE_CLAIM = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

export const ACCESS_ORDER_UPDATE_ADMIN_AGREEMENT = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

export const ACCESS_ORDER_UPDATE_ADMIN_PO = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

export const ACCESS_ORDER_UPDATE_DESCRIPTION = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

export const ACCESS_ORDER_UPDATE_COMMENTS_REGISTRATION = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

export const ACCESS_ORDER_UPDATE_COMMENTS_INTERNALS = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

export const ACCESS_ORDER_UPDATE_SUBCONTRACTOR = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

export const ACCESS_ORDER_DELETE_SUBCONTRACTOR = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

export const ACCESS_ORDER_DELETE_FILES = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

export const ACCESS_ORDER_ACTIONS_PHOTO_SHARE_UPDATE = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

export const ACCESS_ORDER_MAP_POINTS_REPORT_DELETE = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

export const ACCESS_ORDER_MAP_POINTS_SHARE_GENERATE = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

// transport order details - buttons
export const ACCESS_TRANSPORT_ORDER_DETAILS_DELETE_BUTTON = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID]
};

// actions
export const ACCESS_ACTION_ADD_BUTTON = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};
export const ACCESS_ACTION_EDIT_BUTTON = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};
export const ACCESS_ACTION_REMOVE_BUTTON = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};
export const ACCESS_ACTION_SHOW_HIDE_BUTTON = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

// demPoints
export const ACCESS_DEMPOINT_ACTIVATE_DEACTIVATE_BUTTON = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};
export const ACCESS_DEMPOINT_ADD_EDIT_NOTE_BUTTON = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

// adding workers
export const ACCESS_ADD_WORKER_TO_ORDER_BUTTON = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

// settlement comment
export const ACCESS_SETTLEMENT_COMMENT_VIEW = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    RBS_COORDINATOR_TYPE_ID
  ]
};

export const ACCESS_SETTLEMENT_COMMENT_MODIFY = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

// actions register
export const ACCESS_ACTIONS_REGISTER_TABLE_REQUEST_REPORT_BUTTON = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    RBS_COORDINATOR_TYPE_ID
  ]
};

// user
export const ACCESS_UPDATE_USERS_2FA = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID]
};

export const ACCESS_USER_CREATE = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID]
};
export const ACCESS_USER_UPDATE = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID]
};
export const ACCESS_OTHER_USER_PASSWORD_UPDATE = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID]
};

// dictionaries view columns
export const ACCESS_DICTIONARIES_VIEW_ID_COLUMN = {
  userTypesWithAccess: [DEV_TYPE_ID]
};

export const ACCESS_DELETE_ORDER_REPORT_BUTTON = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID]
};

export const ACCESS_DELETE_ACTION_REPORT_BUTTON = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID]
};

export const ACCESS_COUNTY_CONTRACTOR_EDIT_BUTTON = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

export const ACCESS_ORDER_REPO_SHARE_FILE_TO_MOBILE_APP = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

// transport orders
export const ACCESS_TRANSPORT_ORDER_ASSIGN_DRIVER = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    TRANSPORT_MANAGER_TYPE_ID
  ]
};

export const ACCESS_TRANSPORT_ORDER_ARCHIVE = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    TRANSPORT_MANAGER_TYPE_ID
  ]
};

export const ACCESS_TRANSPORT_ORDER_COMPLETE = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    TRANSPORT_MANAGER_TYPE_ID
  ]
};

export const ACCESS_TRANSPORT_ORDER_DRIVER_CREATE = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    TRANSPORT_MANAGER_TYPE_ID
  ]
};

export const ACCESS_TRANSPORT_ORDER_DRIVER_PERFORM = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    TRANSPORT_MANAGER_TYPE_ID
  ]
};

export const ACCESS_TRANSPORT_ORDER_DRIVER_VERIFY = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    TRANSPORT_MANAGER_TYPE_ID
  ]
};

export const ACCESS_TRANSPORT_ORDER_DRIVER_NOTE_UPDATE = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    TRANSPORT_MANAGER_TYPE_ID
  ]
};

export const ACCESS_TRANSPORT_ORDER_DRIVER_ADDITIONAL_STATUS_UPDATE = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    TRANSPORT_MANAGER_TYPE_ID
  ]
};

export const ACCESS_TRANSPORT_ORDER_REPO_SHARE_FILE_TO_MOBILE_APP = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    TRANSPORT_MANAGER_TYPE_ID
  ]
};

export const ACCESS_TRANSPORT_ORDER_DELETE_FILES = {
  userTypesWithAccess: [
    ADMIN_TYPE_ID,
    DEV_TYPE_ID,
    RADO_COORDINATOR_TYPE_ID,
    TRANSPORT_MANAGER_TYPE_ID
  ]
};

// order contractors
export const ACCESS_ORDER_CONTRACTOR_STOP_ORDER = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

export const ACCESS_ORDER_CONTRACTOR_CANCEL_ORDER = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

export const ACCESS_ORDER_CONTRACTOR_LN_UPDATE = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

export const ACCESS_ORDER_PG_RELATED_MODIFY = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

export const ACCESS_ORDER_PO_RELATED_MODIFY = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

export const ACCESS_ORDER_ADDITIONAL_INFO_UPDATE = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

export const ACCESS_ORDER_DOCUMENTS_UPLOAD = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};

export const ACCESS_SINGLE_ACTION_GALLERY_DELETE_FILES = {
  userTypesWithAccess: [ADMIN_TYPE_ID, DEV_TYPE_ID, RADO_COORDINATOR_TYPE_ID]
};
